class ScrollCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-scroll-carousel-track]');
    this.prevButton = this.querySelector('[data-scroll-carousel-prev]');
    this.nextButton = this.querySelector('[data-scroll-carousel-next]');

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByDirection(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByDirection(1));
  }

  scrollByDirection(direction) {
    if (!this.track) return;
    const item = this.track.querySelector('[data-scroll-carousel-item]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
    const amount = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }
}

if (!customElements.get('scroll-carousel')) {
  customElements.define('scroll-carousel', ScrollCarousel);
}
